import React from "react";
import { useNavigate } from "react-router-dom";
import FinancialHygienecomponents from "./FinancialHygienecomponents";
import CallToAction from "./CallToAction";

const FinancialHygieneInfo = () => {
    const navigate = useNavigate();

    return (
        <>
            <div className="other-pages-main-section financial-hygiene-fin">
                <h2 className="other-pages-title">Financial Hygiene & Managed Accounting </h2>
                <p>
                    <span onClick={() => navigate("/")} style={{ cursor: "pointer" }}>Home</span> /
                    <span onClick={() => navigate("/financial-hygiene-managed-accounting")} style={{ cursor: "pointer" }}>Financial Hygiene & Managed Accounting</span>
                </p>
            </div>
            <FinancialHygienecomponents />
            <CallToAction />
        </>
    );
};

export default FinancialHygieneInfo;
